<template>
  <div>
    <div v-if="!isDraft" class="flex flex-col">
      <OhVueIcon :name="arrowBtm" scale="2" class="text-grey-425 self-center" />
    </div>
    <div class="flex items-center">
      <div class="w-2 mr-1 shrink-0">
        <Triangle :class="{ '[&>path]:fill-black!': !isCurrent }" aria-hidden="true" />
      </div>
      <div
        class="px-4 py-2.5 grow flex flex-row gap-1 justify-between items-center"
        :class="{
          'border-2 rounded-lg': !isCurrent,
          'bg-white border border-blue-france-sun-113 rounded-md': isCurrent,
        }"
      >
        <div v-if="isDraft" class="text-grey-425 text-sm">Initié par</div>
        <AbsenceIndicator
          v-if="element.absence"
          :name="element.name"
          :absence="element.absence"
          :civility="element.civility"
        />
        <p class="grow" :class="{ 'py-2': !isDraft, 'py-1': isDraft, 'font-bold': isCurrent }">
          {{ element.name }}
        </p>
        <PTooltip v-if="isCurrent" :label="`Ajouter ${element.name} en bas du flux`" :delay="500" :offset="5">
          <PButton
            size="icon"
            mode="tertiary-borderless"
            :data-sentry-id="`AddEndStreamBtn-${element.id}`"
            :aria-label="`Ajouter ${element.name} en bas du flux`"
            @click="emit('addToEndStream')"
          >
            <OhVueIcon :name="addUserIcon" class="text-success" />
          </PButton>
        </PTooltip>
        <PTooltip
          v-if="!isCurrent && !letterFileStore.balaWhiteList.includes(element.mail)"
          :label="`Inviter ${element.name} à revoir le parapheur`"
          :delay="500"
          :offset="5"
        >
          <PButton
            @click="seeAgainDownstream(letterFile.id, element)"
            :data-sentry-id="`SeeAgainBtn-${element.id}`"
            :aria-label="`Inviter ${element.name} à revoir le parapheur`"
            size="icon"
            mode="tertiary-borderless"
          >
            <OhVueIcon :name="bellIcon" class="text-blue-france-sun-113" />
          </PButton>
        </PTooltip>
      </div>
    </div>
    <div class="flex flex-col">
      <OhVueIcon :name="arrowBtm" scale="2" class="text-grey-425 self-center" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { type FluxElementDto } from "@/app/dto/flux-element.dto";
import { type LetterFileDto, LetterFileStatus } from "@/app/dto/letter-file.dto";
import { useLetterFileStore } from "@/app/stores/letter-file.store";
import { seeAgainDownstream } from "@/app/utils/see-again.ts";
import AbsenceIndicator from "@/app/views/LetterFileForm/Flux/AbsenceIndicator.vue";
import { PButton, PTooltip, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { OiBell, RiArrowDropDownFill, RiUserAddFill } from "oh-vue-icons/icons";
import { computed } from "vue";
import Triangle from "../../../media/triangle.svg?component";

interface Props {
  element: FluxElementDto;
  letterFile: LetterFileDto;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: "addToEndStream"): void;
}>();

const letterFileStore = useLetterFileStore();

const [arrowBtm, bellIcon, addUserIcon] = useIcons(RiArrowDropDownFill, OiBell, RiUserAddFill);

const isDraft = computed(() => props.letterFile.draft);
const isCurrent = computed(() => props.letterFile.status === LetterFileStatus.CURRENT);
</script>
